import { Outlet, useLocation } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useThemeMode } from "context/ThemeContaxt/ThemeModeContext";
import { getModuleTheme } from "@configure/themes/getModuleTheme";

const ThemedOutletWrapper = () => {
  const { pathname } = useLocation();
  const { mode } = useThemeMode();

  const module = pathname.split("/")[1];
  const theme = getModuleTheme(module, mode);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Outlet />
    </ThemeProvider>
  );
};

export default ThemedOutletWrapper;
